import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_URL } from '@teamfoster/sdk/ssr';

@Injectable({
  providedIn: 'root',
})
export class NewslettersService {
  private http = inject(HttpClient);
  private BASE_URL = inject(BASE_URL, { optional: true })!;

  Subscribe(email: string) {
    return this.http.get<any>(`${this.BASE_URL}api/newsletter/subscribe?email=${email}`);
  }
}
